import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library-shop';
import { StyledOCheckboxItemDiv as StyledCheckboxItemDiv } from '../../organisms/OSearchResults/index.styles';

export const StyledTransportationFilterDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  .checkbox-label {
    padding-left: ${toRem(24)} !important;
  }

  ${StyledCheckboxItemDiv} {
    input[type='checkbox'] + label {
        padding-right: 0;
        width: fit-content;
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 1.625rem;
        &:before {
          top: 0;
          left:0;
        }
        &:after {
          left: 0.375rem;
          top: 0.125rem;
        }
    }
  }
  `}
`;

export const StyledTransportationFilterHeaderContainerDiv = styled.div`
  ${rtl`
  margin-bottom: ${toRem(16)};
  `}
`;
